class WheelpartsCartTerms {
  constructor() {
    this.syncAll();

    document.addEventListener('change', (event) => {
      if (event.target.matches('[data-terms-checkbox]')) this.syncScope(event.target.closest('[data-terms-scope]'));
    });

    document.addEventListener('submit', (event) => {
      const checkout = event.submitter?.matches('[data-terms-checkout]');
      if (!checkout) return;
      const scope = event.submitter.closest('[data-terms-scope]');
      const checkbox = scope?.querySelector('[data-terms-checkbox]');
      if (checkbox && !checkbox.checked) {
        event.preventDefault();
        checkbox.focus();
      }
    });

    new MutationObserver(() => this.syncAll()).observe(document.body, { childList: true, subtree: true });
  }

  syncAll() {
    document.querySelectorAll('[data-terms-scope]').forEach((scope) => this.syncScope(scope));
  }

  syncScope(scope) {
    if (!scope) return;
    const checkbox = scope.querySelector('[data-terms-checkbox]');
    const checkout = scope.querySelector('[data-terms-checkout]');
    if (!checkbox || !checkout) return;
    checkout.disabled = !checkbox.checked || checkout.dataset.cartEmpty === 'true';
    checkout.setAttribute('aria-disabled', checkout.disabled ? 'true' : 'false');
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => new WheelpartsCartTerms(), { once: true });
} else {
  new WheelpartsCartTerms();
}
